import { render, staticRenderFns } from "./checkboxes.vue?vue&type=template&id=5db3e54d&"
import script from "./checkboxes.vue?vue&type=script&lang=js&"
export * from "./checkboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports